// src/components/common/Template_Layouts/configs/primaryColorConfig.js
const primaryColorConfig = [
  {
    name: 'primary-1',
    light: '#10b981', // Emerald 500
    main: '#059669',  // Emerald 600
    dark: '#047857'   // Emerald 700
  }
];

export default primaryColorConfig;
